import SalesPizzasByDiametersList from './SalesPizzasByDiametersList'

export default {
  list: SalesPizzasByDiametersList,
}
